'use strict'



const rg = () => Math.random().toString().slice(3,12)


module.exports = rg;
